import { useTranslations } from 'next-intl';
import {
  format,
  formatDate,
  getEndOfFreeTrialDate,
} from '@monofront/business/utils';
import { useMembershipCouponContext } from '@context/membershipCoupon';
import useSubscriptionPrice from '@hooks/useSubscriptionPrice';
import { useCheckoutPayment } from '../contexts';

interface IMessageMaapProps extends React.HTMLProps<HTMLParagraphElement> {
  paymentText?: string;
}

const MessageMaap: React.FC<IMessageMaapProps> = ({
  paymentText,
  ...props
}) => {
  const tCheckout = useTranslations('Checkout');
  const endOfTrialPeriodDate = formatDate(getEndOfFreeTrialDate());
  const { validatedCoupon } = useMembershipCouponContext();
  const { annualSubscriptionPrice } = useSubscriptionPrice();
  const { selectedNewPaypal } = useCheckoutPayment();

  const price = validatedCoupon?.price ?? annualSubscriptionPrice;
  const formattedPrice = format(price);

  if (paymentText) {
    return (
      <p {...props}>
        {paymentText
          .replace('%DATE%', endOfTrialPeriodDate)
          .replace('%PRICE%', formattedPrice)}
      </p>
    );
  }

  return (
    <p {...props}>
      {tCheckout.rich(
        selectedNewPaypal ? 'maapPaypalPaymentNotice' : 'maapCardPaymentNotice',
        {
          endOfTrialPeriodDate,
          price: formattedPrice,
          comparedPrice: format(annualSubscriptionPrice),
          barred: (children) =>
            children?.[0] !== formattedPrice ? (
              <span className="line-through">{children}</span>
            ) : null,
        },
      )}
    </p>
  );
};

export default MessageMaap;
